<template>
  <div class="osk-with-button-container">
    <b-button
      :disabled="context.attributes.disabled || leftDisabled"
      variant="primary"
      :class="`osk-with-button-btn osk-with-button-btn-left ${
        context.attributes.disabled ? 'cursor-not-allowed' : ''
      }`"
      @click="onLeftClick"
    >
      <b-icon :icon="iconLeft" font-scale="2" />
    </b-button>

    <vue-numeric
      v-model.number="context.model"
      v-bind="context.attributes"
      type="tel"
      :class="`formulate-input-element formulate-input-element--${context.type} osk-with-button-input`"
      :data-type="context.type"
      :disabled="inputDisabled"
      :readonly="isOskEnabled"
      :decimal-separator="decimalSeparator"
      :thousand-separator="thousandSeparator"
      :separator="separator"
      output-type="Number"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
      @touchstart="onTouchStart"
    />

    <b-button
      :disabled="context.attributes.disabled || rightDisabled"
      variant="primary"
      :class="`osk-with-button-btn osk-with-button-btn-right ${
        context.attributes.disabled ? 'cursor-not-allowed' : ''
      }`"
      @click="onRightClick"
    >
      <b-icon :icon="iconRight" font-scale="2" />
    </b-button>
  </div>
</template>
<script>
import VueNumeric from 'vue-numeric'
import { BIcon, BButton } from 'bootstrap-vue'
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'FormulateOskNumberWithButtons',
  components: {
    BIcon,
    BButton,
    VueNumeric,
  },

  props: {
    context: {
      type: Object,
      required: true,
    },
    thousandSeparator: {
      type: String,
      required: false,
      default: undefined,
    },
    iconLeft: {
      type: String,
      default: 'dash',
    },
    iconRight: {
      type: String,
      default: 'plus',
    },
    inputDisabled: {
      type: Boolean,
      default: false,
    },
    leftDisabled: {
      type: Boolean,
      default: false,
    },
    rightDisabled: {
      type: Boolean,
      default: false,
    },
    isOskEnabled: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapState('app/simpleKeyboard', ['currentInputValue', 'activeElement']),

    model() {
      return this.context.model
    },
    decimalPlaces() {
      return this.context.attributes.decimalPlaces || 0
    },
    decimalSeparator() {
      return (
        this.context.attributes['decimal-separator'] ||
        this.context.attributes.decimalSeparator ||
        ','
      )
    },
    separator() {
      return this.context.attributes.separator || this.context.attributes.thousandSeparator || '.'
    },
  },

  watch: {},

  methods: {
    ...mapActions('app/simpleKeyboard', ['showKeyboard', 'hideKeyboard']),

    getNumber(value) {
      if (!value) return value

      const valueSplit = value.split(this.decimalSeparator)
      const integerValue = valueSplit[0].replace(/\D/g, '')
      const result = Number(`${integerValue}.${valueSplit[1] || '00'}`)

      return Number.isNaN(result) ? undefined : result
    },

    onLeftClick(event) {
      this.$emit('leftClick', event)
    },

    onRightClick(event) {
      this.$emit('rightClick', event)
    },

    // eslint-disable-next-line func-names
    onInput: _.debounce(async function (value) {
      this.$emit('onInput', value)
    }, 50),

    // eslint-disable-next-line func-names
    onBlur: _.debounce(async function (event) {
      this.context.blurHandler(event)
      this.$emit('blur', this.model, event)

      if (this.isOskEnabled) {
        this.hideKeyboard()
      }
    }, 50),

    // eslint-disable-next-line func-names
    onFocus: _.debounce(async function (event) {
      document.getElementById(event.target?.id).select()

      this.$emit('focus', this.model, event)

      if (this.applyFocusIntercept(event)) {
        return
      }

      this.inputShowOsk(event)
    }, 50),

    // necessário para impedir teclado nativo
    onTouchStart(event) {
      if (!this.isOskEnabled) return

      event.preventDefault()

      if (this.applyFocusIntercept(event)) {
        return
      }

      this.inputShowOsk(event)
    },

    applyFocusIntercept(event) {
      if (!this.$listeners['focus-intercept']) {
        return false
      }

      // eslint-disable-next-line func-names
      this.$emit('focus-intercept', (showOsk = true) => {
        if (showOsk) this.inputShowOsk(event)
      })

      return true
    },

    inputShowOsk(event) {
      if (!this.isOskEnabled) {
        return
      }

      this.showKeyboard({
        el: event.target,
        layoutType: 'numeric',
        selectAllText: true,
      })
    },
  },
}
</script>

<style lang="scss">
.osk-with-button-container {
  display: flex;

  .osk-with-button-input {
    border-radius: 0 !important;
    text-align: center !important;
    font-size: 1rem !important;

    &[disabled] {
      background-color: white !important;
    }
  }

  .osk-with-button-btn {
    height: 44px;
    width: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
  }

  .osk-with-button-btn-right {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .osk-with-button-btn-left {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .cursor-not-allowed {
    cursor: not-allowed;
  }
}
</style>
